import React, { useEffect } from 'react';

const PrivacyPolicy: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-slate-50 text-slate-900 font-serif">
            {/* Header / Navigation Bar */}
            <header className="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
                <div className="max-w-5xl mx-auto px-6 h-20 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <img src="/supervisor-logo-2026.png" className="w-10 h-10 rounded-lg shadow-sm" alt="Supervisor Eğitim" />
                        <span className="text-xl font-extrabold text-slate-800 tracking-tight font-sans">Supervisor Eğitim</span>
                    </div>
                    <a href="/" className="text-sm font-semibold text-blue-600 hover:text-blue-700 transition-colors font-sans italic">
                        ← Ana Sayfaya Dön
                    </a>
                </div>
            </header>

            {/* Content Section */}
            <main className="max-w-4xl mx-auto px-6 py-16 md:py-24">
                <div className="bg-white p-8 md:p-16 rounded-[2rem] shadow-2xl shadow-slate-200 border border-slate-100">
                    <div className="text-center mb-16">
                        <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 leading-tight">
                            Gizlilik ve Veri Güvenliği Politikası
                        </h1>
                        <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-indigo-600 mx-auto rounded-full mb-6"></div>
                        <p className="text-slate-500 font-medium italic">Son Güncelleme: 9 Şubat 2026</p>
                    </div>

                    <div className="space-y-12 text-lg leading-relaxed text-slate-800">
                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">01</span>
                                Giriş ve Amaç
                            </h2>
                            <p>
                                İşbu Gizlilik Politikası, **Supervisor Eğitim Teknolojileri** ("Platform") tarafından sunulan hizmetlerin ifası sırasında elde edilen kişisel verilerin, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili uluslararası mevzuat (GDPR) çerçevesinde hangi yöntemlerle işlendiğini, saklandığını ve korunduğunu beyan eder. Platformumuz, kullanıcı mahremiyetini akademik bir hassasiyet ve hukuki titizlikle en üst düzeyde korumayı taahhüt eder.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">02</span>
                                Google Veri Kullanımı ve API Rızası
                            </h2>
                            <p className="mb-4">
                                Platformumuz, eğitim süreçlerini optimize etmek amacıyla Google API servislerini kullanmaktadır. Bu kapsamda:
                            </p>
                            <ul className="list-disc pl-8 space-y-3 marker:text-blue-600">
                                <li><strong>Google Takvim (Calendar) Erişimi:</strong> Öğretmenler ve danışmanlar için randevu oluşturma, seans takibi ve Google Meet bağlantıları üretilmesi amacıyla gereklidir.</li>
                                <li><strong>Google Giriş (OAuth 2.0):</strong> Kimlik doğrulama süreçlerinin güvenli bir şekilde yürütülmesi için kullanılır.</li>
                            </ul>
                            <p className="mt-4 bg-blue-50 p-4 rounded-xl border-l-4 border-blue-600 text-sm italic">
                                "Google'dan alınan veriler, hiçbir koşulda üçüncü taraf reklam ağlarına satılmaz ve yalnızca platform işlevselliğinin sağlanması amacıyla kullanılır."
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">03</span>
                                İşlenen Veri Kategorileri
                            </h2>
                            <p className="mb-4">Platform kullanımı sırasında aşağıdaki veri grupları işlenmektedir:</p>
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="p-4 bg-slate-50 rounded-2xl border border-slate-100">
                                    <h3 className="font-bold mb-2">Kimlik Bilgileri</h3>
                                    <p className="text-sm opacity-80 text-slate-600">Ad, soyad, e-posta adresi ve profil fotoğrafı.</p>
                                </div>
                                <div className="p-4 bg-slate-50 rounded-2xl border border-slate-100">
                                    <h3 className="font-bold mb-2">Akademik Veriler</h3>
                                    <p className="text-sm opacity-80 text-slate-600">Öğrenci sınıf seviyesi, sınav sonuçları ve çalışma planları.</p>
                                </div>
                                <div className="p-4 bg-slate-50 rounded-2xl border border-slate-100">
                                    <h3 className="font-bold mb-2">İletişim Verileri</h3>
                                    <p className="text-sm opacity-80 text-slate-600">Telefon numarası ve sistem içi mesajlaşma kayıtları.</p>
                                </div>
                                <div className="p-4 bg-slate-50 rounded-2xl border border-slate-100">
                                    <h3 className="font-bold mb-2">Teknik Veriler</h3>
                                    <p className="text-sm opacity-80 text-slate-600">IP adresi, cihaz bilgileri ve çerez (cookie) kayıtları.</p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">04</span>
                                Veri Güvenliği Önlemleri
                            </h2>
                            <p>
                                Toplanan veriler, endüstri standardı olan **AES-256 şifreleme** yöntemleri ile korunmaktadır. Sunucularımız yüksek güvenlikli veri merkezlerinde barındırılmakta olup, periyodik olarak siber güvenlik denetimlerinden geçirilmektedir. Yetkisiz erişimlerin önlenmesi amacıyla çok katmanlı kimlik doğrulama mimarisi (MFA) uygulanmaktadır.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">05</span>
                                Kullanıcı Hakları (KVKK Madde 11)
                            </h2>
                            <p className="mb-4">Her kullanıcı, veri sorumlusu olan Platformumuza başvurarak:</p>
                            <ul className="list-disc pl-8 space-y-2 opacity-90">
                                <li>Kişisel verilerinin işlenip işlenmediğini öğrenme,</li>
                                <li>Verilerin düzeltilmesini veya silinmesini talep etme,</li>
                                <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesine itiraz etme haklarına sahiptir.</li>
                            </ul>
                        </section>

                        <section className="pt-8 border-t border-slate-100">
                            <p className="text-slate-500 text-sm text-center italic">
                                Bu doktrinal metin, Supervisor Eğitim'in şeffaflık ilkesinin bir tecellisidir. Sorularınız için <strong>supervisoregitim@gmail.com</strong> adresi üzerinden hukuk müşavirliğimizle irtibata geçebilirsiniz.
                            </p>
                        </section>
                    </div>
                </div>
            </main>

            {/* Simple Footer */}
            <footer className="bg-slate-900 text-white py-12 px-6">
                <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
                    <p className="text-slate-400 text-sm italic">© 2026 Supervisor Eğitim. Tüm hakları mahfuzdur.</p>
                    <div className="flex gap-8 text-sm font-medium">
                        <a href="/terms" className="hover:text-blue-400 transition-colors">Kullanım Koşulları</a>
                        <a href="/privacy" className="text-blue-400">Gizlilik Politikası</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PrivacyPolicy;
